var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1699 19.5499L8.43625 13.6037C8.31976 13.4829 8.23616 13.355 8.18544 13.22C8.13473 13.085 8.10937 12.941 8.10937 12.788C8.10937 12.635 8.13473 12.4909 8.18544 12.3559C8.23616 12.221 8.31976 12.0931 8.43625 11.9723L14.1896 6.00559C14.4076 5.77961 14.673 5.66663 14.9861 5.66663C15.2991 5.66663 15.5646 5.77961 15.7825 6.00559C16.0004 6.23158 16.1061 6.51033 16.0995 6.84182C16.0929 7.17328 15.9806 7.45202 15.7627 7.67801L10.8354 12.788L15.7825 17.9185C16.0004 18.1445 16.1094 18.4164 16.1094 18.7342C16.1094 19.052 16.0004 19.3239 15.7825 19.5499C15.5646 19.7759 15.2958 19.8888 14.9762 19.8888C14.6566 19.8888 14.3878 19.7759 14.1699 19.5499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.0c7a696d.svg";
export { ForwardRef as ReactComponent };